module.exports = __webpack_public_path__ + "assets/245d43afa0db68f4fcaf57f4ffad4398.mp3";